// This is a purely presentational component, use with LibraryButtonWrapper.
import React from 'react';

interface LibraryButtonProps {
  isBookmarked?: boolean;
  onLibraryClick?: () => void;
}

const LibraryButton: React.FC<LibraryButtonProps> = ({
  isBookmarked = false,
  onLibraryClick,
}) => (
  <button
    className="work-card--action-button-secondary"
    onClick={onLibraryClick}
  >
    {isBookmarked ? (
      <span>
        <i className="fa fa-check work-card--action-button-icon" />
        <span>Bookmarked</span>
      </span>
    ) : (
      <span>
        <i className="fa fa-plus work-card--action-button-icon" />
        <span>Bookmark</span>
      </span>
    )}
  </button>
);

export default LibraryButton;
